export default __webpack_public_path__ + "static/media/placeholder.e004ef4c.png";